import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { user, role } = useAuth();

  if (user) {
    if (role === "admin") {
      return <Navigate to={"/admin/dashboard"} replace />;
    } else if (role === "officer") {
      return <Navigate to={"/officer/dashboard"} replace />;
    }
  }

  return <>{children}</>;
}
